import type { SqlRunResponse } from '@instamenu/ai-api';

export function readPendingSqlRuns(key: string): SqlRunResponse[] {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(key) ?? '[]');
    if (!Array.isArray(value)) return [];
    return value.filter(
      (run): run is SqlRunResponse =>
        run?.type === 'sql_run' &&
        typeof run.callId === 'string' &&
        typeof run.responseId === 'string' &&
        typeof run.conversationId === 'string' &&
        typeof run.arguments === 'string' &&
        Date.parse(run.expiresAt) > Date.now(),
    );
  } catch {
    return [];
  }
}

export function writePendingSqlRuns(key: string, runs: SqlRunResponse[]) {
  try {
    if (runs.length) sessionStorage.setItem(key, JSON.stringify(runs));
    else sessionStorage.removeItem(key);
  } catch {
    /* Browser storage can be unavailable; the live stream can still complete. */
  }
}
